export default __webpack_public_path__ + "static/media/RhymesWeather_01.b7465fda.png";